import { render, staticRenderFns } from "./event-details.vue?vue&type=template&id=6818c61f&scoped=true&"
import script from "./event-details.vue?vue&type=script&lang=js&"
export * from "./event-details.vue?vue&type=script&lang=js&"
import style0 from "./event-details.vue?vue&type=style&index=0&id=6818c61f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6818c61f",
  null
  
)

export default component.exports